export default "__VITE_ASSET__BOxESDbA__"